import React, { useState } from "react";
import { Drawer, Typography, IconButton, Box } from "@mui/material";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import WidgetsRoundedIcon from "@mui/icons-material/WidgetsRounded";
import LocalMallRoundedIcon from "@mui/icons-material/LocalMallRounded";
import { HeaderItem, EditHeaderBG, EditHeaderLogo } from "./Header";
import LogoMenu from "./LogoMenu";
import ColorPicker from "./ColorPicker";

const MobileHeader = ({
  toggleDrawer,
  headerItemData = {},
  setHeaderItemData,
  editItem = {},
  handleSave,
  handleApi,
  setIsMobile,
  isMobile,
}) => {
  const [searchBarExpand, setSearchBarExpand] = useState(false);
  const [display, setDisplay] = useState(true);

  const handleSearchClose = () => {
    setSearchBarExpand(false);
    setTimeout(() => {
      setDisplay(true);
    }, 250);
  };

  const {
    mobileHeader = {},
    mobileTopbar = {},
    customHeader = {},
  } = headerItemData?.customHeader || {};

  const iconsDimension =
    (mobileHeader?.height ?? 60) < 60 ? "2.2rem" : "2.4rem";

  const { customizeHeader = {} } =
    customHeader;
  const { mobileSearch: searchStyles = {}, mobileItems: itemStyles = {} } =
    customizeHeader;
  const { shadow: searchShadow = {} } = searchStyles;
  const { shadow: itemShadow = {} } = itemStyles;

  // Convert hex color to RGB
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
      : null;
  };

  const searchrgb = hexToRgb(searchShadow?.color || "#6f747d");
  const searchopacity = (searchShadow?.opacity ?? 0) / 100;
  const searchrgba = searchrgb
    ? `rgba(${searchrgb.r}, ${searchrgb.g}, ${searchrgb.b}, ${searchopacity})`
    : `rgba(0, 0, 0, ${searchopacity})`;

  const itemsrgb = hexToRgb(itemShadow?.color || "#6f747d");
  const itemsopacity = (itemShadow?.opacity ?? 0) / 100;
  const itemsrgba = itemsrgb
    ? `rgba(${itemsrgb.r}, ${itemsrgb.g}, ${itemsrgb.b}, ${itemsopacity})`
    : `rgba(0, 0, 0, ${itemsopacity})`;

  return (
    <Box
      sx={{
        backgroundColor: "#333333",
        width: "100%",
        maxWidth: "650px",
        margin: "0 auto",
        overflowX: "hidden",
      }}
    >
      <Drawer
        open={editItem.open && editItem.item === "bgColor"}
        onClose={() => toggleDrawer(false)}
        anchor="right"
        PaperProps={{
          sx: {
            height: "auto",
            width: "370px",
            paddingBottom: "20px",
            overflow: "hidden",
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        {editItem.open && editItem.item === "bgColor" && (
          <ColorPicker
            toggleDrawer={toggleDrawer}
            editItem={editItem}
            handleSave={handleSave}
            initialColor={mobileTopbar?.links[editItem?.index][editItem?.item]}
          />
        )}
      </Drawer>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: `${mobileTopbar?.height ?? 60}px`,
          borderBottom: "1px solid #7f7d7d",
          background: mobileTopbar?.backgroundColor ?? "#000",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            columnGap: "10px",
            flex: 1,
            padding: "0 3px",
          }}
        >
          <HeaderItem
            toggleDrawer={toggleDrawer}
            index={0}
            design={mobileTopbar?.links?.[0]?.design}
            content={mobileTopbar?.links?.[0]?.content}
            action={mobileTopbar?.links?.[0]?.action}
            height={mobileTopbar?.height}
          />

          <IconButton
            onClick={() => {
              toggleDrawer(false);
              setIsMobile(false);
            }}
            sx={{
              p: 0,
              "&.MuiButtonBase-root": {
                padding: 0,
              },
              width: 40,
              height: 40,
              borderRadius: "50%",
              color: "#333",
              backgroundColor: "#ffffff",
              "&:hover": {
                backgroundColor: "#ffffff",
              },
            }}
          >
            <DesktopWindowsIcon />
          </IconButton>
          <HeaderItem
            toggleDrawer={toggleDrawer}
            index={1}
            design={mobileTopbar?.links?.[1]?.design}
            content={mobileTopbar?.links?.[1]?.content}
            action={mobileTopbar?.links?.[1]?.action}
            height={mobileTopbar?.height}
          />
        </Box>
        <Box
          sx={{
            borderLeft: "1px solid #7f7d7d",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 3px",
            rowGap: "5px",
          }}
        >
          <EditHeaderBG
            itemText="Edit BG 1"
            toggleDrawer={toggleDrawer}
            index={0}
            isMobile={isMobile}
            height={mobileTopbar?.height}
          />
        </Box>
      </Box>

      {/* Centered Title Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: `${mobileHeader?.height ?? 60}px`,
          borderBottom: "1px solid #7f7d7d",
          background: mobileHeader?.backgroundColor ?? "#000",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: !display ? "end" : "space-between",
            alignItems: "center",
            columnGap: "10px",
            flex: 1,
            padding: "0 3px",
          }}
        >
          {headerItemData.customHeader?.customHeader?.mobileLogo?.logo ? (
            <img
              src={headerItemData.customHeader?.customHeader?.mobileLogo?.logo}
              alt="Logo"
              style={{
                height:
                  (headerItemData.customHeader?.customHeader?.mobileLogo
                    ?.height || "75") + "px",
                width:
                  (headerItemData.customHeader?.customHeader?.mobileLogo
                    ?.width || "75") + "px",
                display: searchBarExpand ? "none" : "block",
              }}
            />
          ) : (
            <Typography
              variant="h1"
              sx={{
                color: "white",
                fontSize: iconsDimension,
                letterSpacing: "8px",
                fontFamily: "serif",
                fontWeight: 400,
                display: !display ? "none" : "block",
              }}
            >
              SUNDIAL
            </Typography>
          )}

          {/* Icon Buttons */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              columnGap: "15px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                columnGap: "15px",
                flex: 0.3,
              }}
            >
              <Box
                sx={{
                  border: "1px solid transparent",
                  background:
                    headerItemData?.customHeader?.customHeader?.customizeHeader
                      ?.mobileSearch?.borderColor,
                  backgroundOrigin: "border-box",
                  borderRadius: searchBarExpand ? "20px" : "13px",
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    background:
                      headerItemData?.customHeader?.customHeader
                        ?.customizeHeader?.mobileSearch?.backgroundColor ??
                      "#fff",
                    boxShadow: `${searchShadow.inset ? "inset " : ""}${searchShadow.horizontal
                      }px ${searchShadow.vertical}px ${searchShadow.blur}px ${searchShadow.spread
                      }px ${searchrgba}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: searchBarExpand ? "50px" : "13px",
                    height: iconsDimension,
                    width: searchBarExpand ? "15rem" : "2.4rem",
                    transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  {searchBarExpand && (
                    <input
                      className="search-placeholder"
                      placeholder="Search"
                      style={{
                        outline: "none",
                        border: "none",
                        backgroundColor: "transparent",
                        width: "90%",
                        color:
                          headerItemData?.customHeader?.customHeader
                            ?.customizeHeader?.mobileSearch?.textColor ??
                          "#fff",
                      }}
                    />
                  )}
                  {!searchBarExpand && (
                    <SearchIcon
                      sx={{
                        color:
                          headerItemData?.customHeader?.customHeader
                            ?.customizeHeader?.mobileSearch?.textColor ??
                          "#fff",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSearchBarExpand(true);
                        setDisplay(false);
                      }}
                    />
                  )}
                </Box>
              </Box>
              {searchBarExpand && (
                <Box
                  sx={{
                    border: "1px solid transparent",
                    background:
                      headerItemData?.customHeader?.customHeader
                        ?.customizeHeader?.mobileSearch?.borderColor,
                    backgroundOrigin: "border-box",
                    borderRadius: "13px",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    style={{
                      borderRadius: "13px",
                      height: iconsDimension,
                      width: iconsDimension,
                      background:
                        headerItemData?.customHeader?.customHeader
                          ?.customizeHeader?.mobileSearch?.backgroundColor ??
                        "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `${searchShadow.inset ? "inset " : ""}${searchShadow.horizontal
                        }px ${searchShadow.vertical}px ${searchShadow.blur}px ${searchShadow.spread
                        }px ${searchrgba}`,
                      cursor: "pointer",
                    }}
                  >
                    <CloseIcon
                      sx={{
                        color:
                          headerItemData?.customHeader?.customHeader
                            ?.customizeHeader?.mobileSearch?.textColor ??
                          "#fff",
                      }}
                      onClick={handleSearchClose}
                    />
                  </Box>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                border: "1px solid transparent",
                background:
                  headerItemData?.customHeader?.customHeader?.customizeHeader
                    ?.mobileItems?.borderColor,
                backgroundOrigin: "border-box",
                boxShadow: `${itemShadow.inset ? "inset " : ""}${itemShadow.horizontal
                  }px ${itemShadow.vertical}px ${itemShadow.blur}px ${itemShadow.spread
                  }px ${itemsrgba}`,
                borderRadius: "14px",
                cursor: "pointer",
              }}
            >
              <Box
                style={{
                  background:
                    headerItemData?.customHeader?.customHeader?.customizeHeader
                      .mobileItems?.backgroundColor ?? "#fff",
                  borderRadius: "13px",
                  height: iconsDimension,
                  width: iconsDimension,
                  backgroundColor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <WidgetsRoundedIcon
                  fontSize="medium"
                  sx={{
                    color:
                      headerItemData?.customHeader?.customHeader
                        ?.customizeHeader?.mobileItems?.textColor,
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                border: "1px solid transparent",
                background:
                  headerItemData?.customHeader?.customHeader?.customizeHeader
                    ?.mobileItems?.borderColor,
                backgroundOrigin: "border-box",
                boxShadow: `${itemShadow.inset ? "inset " : ""}${itemShadow.horizontal
                  }px ${itemShadow.vertical}px ${itemShadow.blur}px ${itemShadow.spread
                  }px ${itemsrgba}`,
                borderRadius: "14px",
                cursor: "pointer",
              }}
            >
              <Box
                style={{
                  background:
                    headerItemData?.customHeader?.customHeader?.customizeHeader
                      ?.mobileItems?.backgroundColor ?? "#fff",
                  borderRadius: "13px",
                  height: iconsDimension,
                  width: iconsDimension,
                  backgroundColor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <LocalMallRoundedIcon
                  fontSize="medium"
                  sx={{
                    color:
                      headerItemData?.customHeader?.customHeader
                        ?.customizeHeader?.mobileItems?.textColor,
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        {/* Edit buttons container */}
        <Box
          sx={{
            borderLeft: "1px solid #7f7d7d",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 3px",
            rowGap: "5px",
          }}
        >
          <EditHeaderBG
            itemText="Edit BG 2"
            toggleDrawer={toggleDrawer}
            index={1}
            isMobile={isMobile}
            height={mobileHeader.height}
          />
          <EditHeaderLogo
            toggleDrawer={toggleDrawer}
            isMobile={isMobile}
            height={mobileHeader.height}
          />
          <Drawer
            open={
              editItem.open &&
              editItem.item === "logo" &&
              editItem.index === null
            }
            onClose={() => toggleDrawer(false)}
            anchor="right"
            PaperProps={{
              sx: {
                height: "auto",
                width: "370px",
                paddingBottom: "20px",
                overflow: "hidden",
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          >
            {editItem.open && editItem.item === "logo" && (
              <LogoMenu
                toggleDrawer={toggleDrawer}
                editItem={editItem}
                handleSave={handleSave}
                logo={headerItemData?.customHeader?.customHeader?.mobileLogo}
                handleApi={handleApi}
                isMobile={isMobile}
                height={mobileHeader?.height}
              />
            )}
          </Drawer>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileHeader;
